import { array, object, string } from 'prop-types'
import React from 'react'

import * as utils from '../../../external/utilities/GeneralUtils'
import Translate from '../../Translation'
import HackHTag from '../../shared/text/HackHTag'

const FacilityNote = ({
  intl,
  notes,
  note,
  noteType,
  titleKey,
  contractCode = null,
  children,
}) => {
  const keyQualifier = []
  if (!utils.isEmpty(contractCode)) {
    keyQualifier.push(contractCode)
  }
  let currentNote = note
  if (!currentNote) {
    currentNote = utils.findObjectInArray(notes, 'type', noteType)
  }

  if (!currentNote || utils.isEmpty(currentNote.content)) {
    return <i></i>
  }

  if (titleKey) {
    return (
      <div className="note">
        <HackHTag h3>
          <Translate
            intl={intl}
            messageKey={titleKey}
            keyQualifiers={keyQualifier}
          />
        </HackHTag>
        {children}
        <div dangerouslySetInnerHTML={utils.htmlBlock(currentNote.content)} />
      </div>
    )
  }

  return (
    <div className="note">
      {children}
      <div dangerouslySetInnerHTML={utils.htmlBlock(currentNote.content)} />
    </div>
  )
}

FacilityNote.propTypes = {
  intl: object.isRequired,
  notes: array,
  noteType: string,
  note: object,
  titleKey: string,
  contractCode: string,
  children: object,
}

export default FacilityNote
